//All modals constants
const ModalTypeProps = {
  resetPasswordUserPermissionModal: {
    show: true,
    Title: "Create New Password",
    SubmitButtonText: "Submit",
    SubmitButtonVariant: "dark",
    CancelButtonText: "Close",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
  },
  ConfirmationModal: {
    show: true,
    SubmitButtonText: "Yes",
    SubmitButtonVariant: "dark",
    CancelButtonText: "Cancel",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
    backdrop: "static",
  },
  PreviewSurveyModal: {
    show: true,
    SubmitButtonText: "Save",
    SubmitButtonVariant: "dark",
    CancelButtonText: "Discard",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
  },
  AddGroupsModal: {
    show: true,
    AddFranchiseText: "Add Group",
    UpdateFranchiseText: "Update Group",
    SubmitButtonText: "Add",
    SubmitButtonVariant: "dark",
    UpdateButtonText: "Update",
    CancelButtonText: "Cancel",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
  },
  editUserVerificationModal: {
    show: true,
    Title: "Verify Current Password",
    SubmitButtonText: "Submit",
    SubmitButtonVariant: "dark",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
  },
  AddManagerModal: {
    show: true,
    AddManagerText: "Add Manager",
    UpdateManagerText: "Update Manager",
    SubmitButtonText: "Add",
    SubmitButtonVariant: "dark",
    UpdateButtonText: "Update",
    CancelButtonText: "Cancel",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
  },
  archiveQuestionConfirmationModal: {
    show: true,
    Title: "Confirmation",
    SubmitButtonText: "Confirm",
    SubmitButtonVariant: "dark",
    CancelButtonText: "Cancel",
    CancelButtonVariant: "outline-dark",
    ModalSize: "md",
    animate: true,
  },
  allConversationsModal: {
    show: true,
    title: "Internal Notes",
    cancelButtonText: "Cancel",
    cancelButtonVariant: "outline-dark",
    modalSize: "lg",
    animate: true,
  },
  marketingAttributionReportBodyModal: {
    show: true,
    title: "Summary",
    cancelButtonText: "Cancel",
    cancelButtonVariant: "outline-dark",
    modalSize: "lg",
    animate: true,
  },
  FeatureFlagsModal: {
    show: true,
    animate: true,
    ModalSize: "md",
    UpdateButtonText: "Update",
    CancelButtonText: "Cancel",
    SubmitButtonVariant: "dark",
    CancelButtonVariant: "outline-dark",
  },
};

export default ModalTypeProps;
